import UnderskinQuestion from './UnderskinQuestion';

export type { UnderskinQuestionType } from './UnderskinQuestion';

export default UnderskinQuestion;
